<template>
  <overlay-modal ref="overlayModal" width="50%" hideClose>
    <template v-slot:header>
      <div class="">
        <h4 class="cursive">Preventivo creato con successo!</h4>
        <div>
          <span class="text-uppercase pr-2">preventivo n°:</span
          ><span class="text-primary">{{ numeroPratica }}</span>
        </div>
      </div>
    </template>
    <template>
      <div class="container mt-3">
        <h5 class="cursive mb-3">
          Il tuo preventivo numero {{ numeroPratica }} è stato creato con
          successo!
        </h5>
        <p>
          <b
            >Presentati nella tua Agenzia di fiducia, indicando il tuo numero di
            preventivo</b
          >, per ricevere maggiori informazioni, richiedere eventuali modifiche
          e definire tutti i dettagli della tua partenza
        </p>
        <p>
          Al momento nessun volo o servizio a terra è stato prenotato e/o
          opzionato.
        </p>
        <p>
          Prezzi e disponibilità sono soggetti a riconferma al momento della
          prenotazione in Agenzia.
        </p>
        <div class="d-flex mb-5">
          <button
            id="visualizzaRiepilogo"
            class="btn btn-primary px-5"
            @click="onVisualizza"
          >
            Visualizza il riepilogo del tuo viaggio
          </button>
        </div>
        <div v-if="toSend" class="bg-light px-4 py-5 mb-4">
          <p>
            Per ricevere il preventivo via email, inserisci il tuo indirizzo di
            posta nella casella sottostante.
          </p>
          <p class="mb-2">Nessun dato personale verrà salvato.</p>
          <div class="d-md-flex justify-content-md-between">
            <input
              type="email"
              class="form-control mr-3 mb-1"
              placeholder="Inserisci la tua email"
              v-model="email"
            />
            <button
              id="inviaRiepilogo"
              class="btn btn-primary text-uppercase px-5"
              :disabled="!isValidEmail"
              @click="onInviaEmail"
            >
              invia
            </button>
          </div>
        </div>
        <div class="text-center">
          <a
            href="/"
            class="default-bold text-uppercase text-secondary"
            @click="trackModaleCompletaPreventivoChiudi()"
            >torna alla home</a
          >
        </div>
      </div>
    </template>
  </overlay-modal>
</template>

<script>
import { mapGetters } from "vuex";
import OverlayModal from "../../../modals/OverlayModal";
import InviaMailAction from "../../../actions/InviaMailAction";
import { emailIsValid } from "../../../../utils/helper";
import AnalyticEvents from "../../../common/AnalyticEvents";

export default {
  name: "ModalCompletaPratica",
  mixins: [InviaMailAction, AnalyticEvents],
  components: { OverlayModal },
  data() {
    return {
      email: "",
      toSend: true,
    };
  },
  computed: {
    isValidEmail() {
      return this.email.length > 3 && emailIsValid(this.email);
    },
    preventivo() {
      return this.getPreventivo();
    },
    numeroPratica() {
      return this.preventivo.numeroPratica;
    },
    urlStampaFlexy() {
      return this.preventivo.urlStampaFlexy;
    },
  },
  methods: {
    ...mapGetters(["getPreventivo"]),
    open() {
      this.$refs.overlayModal.open();
    },
    close() {
      this.$refs.overlayModal.close();
    },
    onInviaEmail() {
      this.inviaEmail(this.email).then(() => {
        this.toSend = false;
      });
    },
    onVisualizza() {
      this.trackModaleCompletaPreventivoVisualizza();
      const arrUrl = this.urlStampaFlexy.split(";");
      window.open(arrUrl[0], "_blank");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalCompletaPratica.vue